import React, { useRef } from 'react';
import { DataGrid } from 'devextreme-react';
import { Column, Editing, Lookup, Pager, Paging, Summary, TotalItem } from 'devextreme-react/data-grid';
import BlockHeader from '../../components/shared/BlockHeader';
import { onCellPreparedReceipt } from '../../components/bill/CellPrepared';
import { cellRender, dataFormatId, formatId, formatIdValue, formatToMoney } from '../../utils/common';
import { store } from '../../services/store';
import uri from '../../utils/uri';
import { formatDate, formatDateTime } from '../../data/app';
import urlReport from '../../services/reportServices';

const ReceiptByBillId = (props) => {

    const { onSave } = props;
    const refGrid = useRef();

    const onRowRemoved = (e) => {
        onSave();
    }

    const addMenuItems =(e) => {
        
        if (e.target == "content") {
            
            // e.items can be undefined
            if (!e.items) e.items = [];
 
            // Add a custom menu item
            if(e.rowIndex >= 0)
                e.items.push({

                    text: `Imprimir recibo`,
                    icon : 'print',
                    onItemClick: () => {
                        const report = urlReport();
                        report.print(`${report.receiptTicket(e.row.data.id)}`);
                    }
                    
                });
           
        }
    }

    const { id, reference, cliente } = props;
    const title = `Recibos generados de la factura ${formatIdValue(reference)}`;
    const titleCliente = `Cliente: ${cliente}`;
    
    return (<>
            <BlockHeader title={title} />
            <BlockHeader title={titleCliente} />
            <DataGrid
                id="gridReceipt"
                ref={refGrid}
                selection={{ mode: 'single' }}
                dataSource={store({ uri: { get : uri.receivables.byBill(id), remove : uri.receivables.remove } })}
                showBorders={true}
                showRowLines={true}
                allowColumnResizing={true}
                allowColumnReordering={true}
                rowAlternationEnabled={true}        
                onCellPrepared={onCellPreparedReceipt}     
                onRowRemoved={onRowRemoved}     
                onContextMenuPreparing={addMenuItems} 
            >
                <Paging defaultPageSize={20} />
                <Pager
                    showInfo={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={[10, 20, 50]}
                />
                <Column dataField="id" caption="Id" width={100} cellRender={dataFormatId} visible={false} />
                <Column dataField="numberReceipt" caption="Recibo #" width={100} cellRender={dataFormatId} />
                <Column dataField="date" caption="Fecha" dataType='date' format={formatDate} width={110} />
                <Column dataField="amount" caption="Pagado"  width={120} cellRender={cellRender()} />
                <Column dataField="balance" caption="Pendiente"  width={100} cellRender={cellRender()} />
                <Column dataField="observation" caption="Observacion"  />
                <Column dataField="createBy" caption='Creado por' width={120} visible={false} />
                <Column dataField="createAt" caption="Creadi el" dataType='date' format={formatDateTime} width={120} />
                <Summary>                
                    <TotalItem
                        column="amount"
                        summaryType="sum" 
                        customizeText={data => `Total: ${formatToMoney(data.value)}`} />
                </Summary>              
            </DataGrid>
    </>);
    
}

export default ReceiptByBillId;
